import { DdiziRecentHistoryType } from '@kinderlabs-pos/apis/pos';
import { DdiziType } from '@kinderlabs-pos/shared-data-type';
import { DdiziState } from '@kinderlabs-pos/state';
import { useConfirm } from '@kinderlabs-pos/ui-components';
import { useState } from 'react';
import { TicketEnterButton } from '../../modules/tickets/components/buttons/TicketEnterButton';
import { TicketEnterCancelButton } from '../../modules/tickets/components/buttons/TicketEnterCancelButton';
import { TicketExitButton } from '../../modules/tickets/components/buttons/TicketExitButton';
import { TicketExitCancelButton } from '../../modules/tickets/components/buttons/TicketExitCancelButton';
import { ExitBeaconTagConfirmDialog } from '../ExitPage/ExitBeaconTagConfirmDialog';

export interface IDdiziEnterExitButtonsProps {
	ddizi: DdiziType;
	recentHistory?: DdiziRecentHistoryType;
}
export const DdiziEnterExitButtons: React.FC<IDdiziEnterExitButtonsProps> = ({
	ddizi,
	recentHistory,
}) => {
	const confirm = useConfirm();
	const enterExit = DdiziState.actions.useEnterExit();
	const [beaconTagDialogOpen, setBeaconTagDialogOpen] = useState(false);

	const doExit = () => enterExit.mutate({ ddiziId: ddizi.id, type: 'EXIT' });

	const handleEnter: React.MouseEventHandler = (e) => {
		e.stopPropagation();
		confirm('지금 시점부터 입장 처리 하시겠습니까?', () =>
			enterExit.mutate({ ddiziId: ddizi.id, type: 'ENTER' })
		);
	};

	const handleExit: React.MouseEventHandler = (e) => {
		e.stopPropagation();
		if (ddizi.beaconTagId != null) {
			setBeaconTagDialogOpen(true);
		} else {
			confirm('추가 요금 없이 퇴장 처리 하시겠습니까?', doExit);
		}
	};

	const handleCancelEnter: React.MouseEventHandler = (e) => {
		e.stopPropagation();
		confirm('입장 처리를 취소하시겠습니까?', () =>
			enterExit.mutate({ ddiziId: ddizi.id, type: 'CANCEL_ENTER' })
		);
	};

	const handleCancelExit: React.MouseEventHandler = (e) => {
		e.stopPropagation();
		const isBeaconConnected = recentHistory && recentHistory.status === 'RETURN';

		confirm(
			isBeaconConnected
				? '퇴장을 취소하면 입장 상태는 복구되지만, 반납 처리된 팔찌 연결은 복구되지 않습니다. 계속하시겠어요?'
				: '퇴장 처리를 취소하시겠습니까?',
			() => enterExit.mutate({ ddiziId: ddizi.id, type: 'CANCEL_EXIT' })
		);
	};

	return (
		<>
			<ExitBeaconTagConfirmDialog
				open={beaconTagDialogOpen}
				beaconTagCount={1}
				confirmMessage='추가 요금 없이 퇴장 처리 하시겠습니까?'
				closeDialog={() => setBeaconTagDialogOpen(false)}
				onConfirm={doExit}
			/>
			{ddizi.status === 'PUBLISHED' ? (
				<TicketEnterButton onClick={handleEnter} />
			) : (
				<TicketEnterCancelButton
					onClick={handleCancelEnter}
					disabled={ddizi.status == 'EXITED'}
				/>
			)}
			{ddizi.status === 'EXITED' ? (
				<TicketExitCancelButton onClick={handleCancelExit} />
			) : (
				<TicketExitButton
					onClick={handleExit}
					disabled={ddizi.status == 'PUBLISHED'}
				/>
			)}
		</>
	);
};
